// extracted by mini-css-extract-plugin
export default {"descriptionTitle":"InputField_descriptionTitle__vun0Q","description":"InputField_description__VLUBm","sliderDescription":"InputField_sliderDescription__ya9ki"};